import React from 'react'
import CoordinatorTrainerAssign from './CoordinatorTrainerAssign'

const CoordinatorTrainerAssignPage = () => {
    return (
        <CoordinatorTrainerAssign />
    )
}

export default CoordinatorTrainerAssignPage